//import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
//import SimpleBar from 'simplebar';

/*
class VerticalScrollPlugin extends ScrollbarPlugin {
  static pluginName = 'VerticalScrollPlugin';

  transformDelta(delta, fromEvent) {

    if (!/wheel/.test(fromEvent.type)) {
      return delta;
    }
       
    const { x, y } = delta; 

    return {
        y: y,
        x: 0,
    };
  }
}


Scrollbar.use( VerticalScrollPlugin );
*/


var mobileNavigation = {

    selectors: {
        trigger: '[data-mobile-navigation="trigger"]',
        target:  '[data-mobile-navigation="target"]',
    },

    init: function() {
        var self = this,
            $hamburger = $( self.selectors.trigger ),
            $navigation = $( self.selectors.target );

        var navigation = document.querySelector( '.mobile-navigation__wrapper' );
        //var scrollbar = Scrollbar.init( document.querySelector( '.menu-scrollable' ) );

        $hamburger.on( 'click', function( e ) {
            $navigation.addClass( 'navigation--animate' );
            $( document.body ).toggleClass( 'navigation-opened' );

            if ( $( document.body ).hasClass( 'navigation-opened' ) ) {
                disableBodyScroll( navigation );
                //scrollbar.update();
            } else {
                enableBodyScroll( navigation );
            }
        } );

        $( '.site__overlay' ).on( 'click', function() {
            $( document.body ).removeClass( 'navigation-opened' );

            enableBodyScroll( navigation );
        } )

        $( '[data-child-level]' ).on( 'click', function(e) {
            e.preventDefault();

            var $this = $( this ),
            $submenu = $this.siblings( '.subsubsub' ),
            childLevel = parseInt( $this.attr( 'data-child-level' ) ),
            translateX = childLevel * -100;

            $( '.subsubsub' ).removeClass( 'slide-visible' );
            $submenu.addClass( 'slide-visible' );
            $( '.mobile-navigation__slider' ).css( 'transform', 'translate3d(' + translateX + '%, 0, 0)' );
        } );

        $( '[data-parent-level]' ).on( 'click', function(e) {
            e.preventDefault();

            var $this = $( this ),
            childLevel = parseInt( $this.attr( 'data-parent-level' ) ),
            translateX = childLevel * -100;

            setTimeout( function() {
                $( '.subsubsub' ).removeClass( 'slide-visible' );
            }, 500 );

            $( '.mobile-navigation__slider' ).css( 'transform', 'translate3d(' + translateX + '%, 0, 0)' );
        } );

        $( window ).on( 'resize', function( e ) {
            //$navigation.removeClass( 'navigation--animate' );
            //$( document.body ).removeClass( 'navigation-opened' );
            //scrollbar.update();
        } );
    },
}

export {
    mobileNavigation
};
